import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import chunk from 'lodash/chunk';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import VideosItem, { TYPES } from 'shared/components/VideosItem/VideosItem';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import s from './NewsBlock.css';

const DEFAULT_CONTAINER_WIDTH = 820;
const MAX_MOBILE_WIDTH = 560;

class VideoBlock extends React.Component {
  static propTypes = {
    news: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    title: PropTypes.string,
    maxMobileWidth: PropTypes.number,
    columns: PropTypes.number,
    handleShowVideo: PropTypes.func.isRequired,
    children: PropTypes.node,
  };
  static defaultProps = {
    title: null,
    maxMobileWidth: MAX_MOBILE_WIDTH,
    columns: 3,
    children: null,
  };

  state = {
    containerWidth: DEFAULT_CONTAINER_WIDTH,
    maxMobileWidth: this.props.maxMobileWidth,
  };

  componentDidMount() {
    const containerWidth = this.root && this.root.parentNode && this.root.parentNode.offsetWidth;

    if (containerWidth) {
      this.setContainerWidth(containerWidth);
    }
  }

  setContainerWidth = containerWidth => {
    this.setState({ containerWidth });
  };

  render() {
    const { title, news, columns: defaultColumns, children, handleShowVideo } = this.props;
    const { containerWidth, maxMobileWidth } = this.state;

    const columns = containerWidth < maxMobileWidth ? 1 : defaultColumns;

    const rows = chunk(news, columns);

    return (
      <div
        className={cx(s.root, s.videoBLock)}
        ref={el => {
          this.root = el;
        }}
      >
        {title && <h3 className={s.videoTitle}>{title}</h3>}

        <div className={s.newsContainer}>
          {rows.map(newsItems => (
            <div key={newsItems[0].id} className={s.row}>
              {newsItems.map((item, index) => (
                <VideosItem
                  handleShowVideo={handleShowVideo}
                  type={TYPES.LIST}
                  key={item.id}
                  imgHeight={130}
                  imgWidth={200}
                  index={index}
                  {...item}
                />
              ))}
            </div>
          ))}
        </div>
        {children}
      </div>
    );
  }
}

export default withStyles(s)(withPixelRatio(VideoBlock));



// WEBPACK FOOTER //
// ./src/desktop/components/NewsBlock/VideoBlock.js